<template>
	<div class="forbidden-container">
		<h1>403</h1>
		<h5>{{ $t('errors.forbidden.title') }}</h5>
		<n-button @click="goBack" class="secondary-button">{{ $t('errors.forbidden.back') }}</n-button>
	</div>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router"
import { NButton } from "naive-ui"

const router = useRouter()
const goBack = () => router.back()
</script>

<style lang="scss" scoped>
.forbidden-container {
	@include flex(2.4rem, column, center, center);

	height: 100vh;
}

h1 {
	@include getFont('h1');
	color: var(--red);
}

h5 {
	@include getFont('c1-bold');
	color: var(--gs-300);
}
</style>
